import styled from 'styled-components'
import pxToRem from '../../utils/pxToRem'

export const StyledText = styled.div`
  position: relative;
  overflow: hidden;
  display: flex;
  height: 100%;
  padding-right: ${pxToRem(20)};
  padding-bottom: ${pxToRem(10)};
  margin-top: ${({ $hasTitle }) => ($hasTitle ? pxToRem(3) : pxToRem(5))};
  margin-bottom: ${pxToRem(10)};
  font-size: ${({ theme }) => theme.fonts.sizes.base};
  line-height: ${({ theme }) => theme.fonts.lineHeight.base};
  font-weight: ${({ theme }) => theme.fonts.weight.regular};
  overflow-y: auto;
`
